import React, { useEffect, useState } from "react";
import { Search, Check } from "lucide-react";

const BASE = "https://webhook.harmonyalgo.com/api";

const Row = ({ payment, formatDate, approvePayment }) => {
  return (
    <tr
      key={payment.id}
      className={`transition-colors ${
        payment.is_first_payment
        ? " bg-orange-300/15 hover:bg-amber-500/10"
        : "hover:bg-zinc-800/50"}`}
    >
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        {payment.tradingview_username}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        {payment.discord_username}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        {payment.email}
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-zinc-800 text-zinc-100 border border-zinc-700" title={payment.payment_link}>
          {payment.payment_link_label}
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400">
        {payment.amount / 100}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400">
        {formatDate(payment.created_at)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400/50">
        {payment.is_approved ? (
          <i className="block h-8 leading-7 align-middle">Approved.</i>
        ) : (
          <button
            className="mr-4 p-1 bg-teal-500 text-white text-sm rounded hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500"
            onClick={() => approvePayment(payment.id)}
          >
            <Check />
          </button>
        )}
      </td>
    </tr>
  );
};

const Payments = ({ formatDate }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(`${BASE}/payments`);
      const resJson = await res.json();
      setTableData(resJson);
    };
    fetchData();
  }, []);

  const approvePayment = async (id) => {
    const res = await fetch(`${BASE}/approve_payment`, {
      method: "POST",
      body: JSON.stringify({ id }),
      headers: { "Content-Type": "application/json" },
    });
    const resJson = await res.json();
    console.log(resJson)
    setTableData(
      tableData.map((data) =>
        data.id === id ? { ...data, is_approved: true } : data,
      ),
    );
  };

  const filteredData = tableData.filter(
    (item) =>
      item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.payment_link.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="rounded-lg border border-zinc-800 bg-zinc-900">
      {/* Search kutusu */}
      <div className="p-6 border-b border-zinc-800">
        <div className="flex items-center justify-between">
          <div className="relative">
            <Search
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-zinc-400"
              size={20}
            />
            <input
              type="text"
              placeholder="Search payments..."
              className="pl-10 pr-4 py-2 w-80 bg-zinc-800 text-zinc-100 border border-zinc-700 rounded-md focus:outline-none focus:ring-2 focus:ring-zinc-600 focus:border-zinc-600 placeholder-zinc-400"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="text-sm text-zinc-400">
            {filteredData.length} payments
          </div>
        </div>
      </div>

      {/* Tablo */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-zinc-800">
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                TradingView Username
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Discord Username
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Payment Link
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Amount
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Created At
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {filteredData.map((payment) => (
              <Row
                payment={payment}
                formatDate={formatDate}
                approvePayment={approvePayment}
              />
            ))}
            {filteredData.length ? null : (
              <td className="m-4 px-1 py-4 whitespace-nowrap text-sm text-zinc-100">
                No items.
              </td>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export { Payments }
